// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NavBarWrapper_wrapper__2QMJ_"};